import { MainFooter } from "@layouts/MainLayout/MainFooter";
import React from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { SecondHeader } from "./SecondHeader";
import styles from "./styles/SecondLayout.module.css";

const SecondLayout = () => {
  return (
    <div style={{ backgroundColor: "#f7f7f7" }}>
      <ToastContainer className={styles.toastContainer} />
      <SecondHeader />
      <div style={{ paddingTop: "60px" }}>
        <Outlet />
      </div>
      <MainFooter />
    </div>
  );
};
/* required: display name */
SecondLayout.displayName = "SecondLayout";

/* required: props types */
SecondLayout.propTypes = {};

/* required: default props */
SecondLayout.defaultProps = {};
export { SecondLayout };
